import React, { useEffect, useState, useMemo } from 'react';
import { useAccountStore } from 'src/hooks/admin/account';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Admin from "@system/config/admin";
import { AgGridReact } from 'ag-grid-react';

import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/support/Helper';
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/support/Constants';

const AccountList = () => {
    const [__check] = useAxiosIndicatorCheck();

    const [{ accountList, totalRecords, filteredRecords }, { get_account_list, get_account_export, email_accouts }, { set_account_list }] = useAccountStore();
    const [userListErrAlert, setUserListErrAlert] = useReduxState("", "setUserListErrAlert");
    const [errAlertType, setErrAlertType] = useReduxState("", "setErrAlertType");
    const [gridApi, setGridApi] = useState(null);
    const [rowData, setRowData] = useState([]);
    const gridRef = React.useRef();
    const [{ filter_list }, { }, { }] = useAdminAccountFilterStore();
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [agGridFiltered, setAgGridFiltered] = useState(0);

    useEffect(() => {
        async function fetchHere() {
            await fetchAPICall()
        }
        fetchHere();

    }, [filter_list]);

    const loadAccountDetail = (e) => {
        const data = e?.data ? e?.data : e.node.allLeafChildren[0].data;
        return <>
            <a href={Admin.getAdminAccountDetailURL() + '?accountNumber=' + data.AccountNumber + '&salesOrg=' + data.SalesOrg + '&speedboat=' + (data.SpeedBoot === "Silica" ? 'S' : (data.SpeedBoot === "Abacus" ? 'T' : 'B'))} className='' target="_blank"> {e?.value}</a>
        </>
    }

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            sortable: true,
            filter: true,
            enableRowGroup: true,
            enableValue: true,
            // lockPinned: true,
            resizable: true
        };
    }, []);

    useEffect(() => {
        let _accountList = [];
        if (accountList?.length > 0) {
            accountList.map((_account, idx) => {
                let _data = {
                    AccountNumber: _account.accountNumber,
                    AccountName: _account.accountName,
                    SpeedBoot: _account.speedBoat === 'T' ? 'Abacus' : _account.speedBoat === 'S' ? 'Silica' : 'EBV',
                    SalesOrg: _account.salesOrg,
                    Description: _account.description,
                    Status: _account.status ? 'Active' : 'Inactive',
                    CreatedOn: _account.createdOn ? Helper.getDatepickerFormatAdminConsole(_account.createdOn) : "",
                    UpdatedOn: _account.updatedOn ? Helper.getDatepickerFormatAdminConsole(_account.updatedOn) : "",
                    BillToCountry: _account.billToCountry,
                    Currency: _account.courrency,
                    OrderBlock: _account.orderBlock === true ? 'Yes' : _account.orderBlock === false ? 'No' : '',
                    CreditRisk: _account.creditRisk === true ? 'Yes' : _account.creditRisk === false ? 'No' : '',
                    Payment: _account.payment,
                    SdiNumber: _account.sdiNumber,
                    PecEmail: _account.pecEmail,
                }
                _accountList.push(_data);
            })
        }
        setRowData(_accountList)
    }, [accountList]);

    const [columnDefs, setColumnDefs] = useState([
        { field: 'AccountNumber', headerName: 'ACCOUNT NUMBER', headerTooltip: 'ACCOUNT NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellRenderer: loadAccountDetail, minWidth: 150 },
        { field: 'AccountName', headerName: 'ACCOUNT NAME', headerTooltip: 'ACCOUNT NAME', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'SpeedBoot', headerName: 'SPEEDBOAT', headerTooltip: 'SPEEDBOAT', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'SalesOrg', headerName: 'SALES ORG', headerTooltip: 'SALES ORG', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'Description', headerName: 'DESCRIPTION', headerTooltip: 'DESCRIPTION', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'Status', headerName: 'STATUS', headerTooltip: 'STATUS', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'BillToCountry', headerName: 'BILL TO COUNTRY', headerTooltip: 'BILL TO COUNTRY', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'Currency', headerName: 'CURRENCY', headerTooltip: 'CURRENCY', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        {
            field: 'CreatedOn',
            headerName: 'CREATED ON',
            headerTooltip: 'CREATED ON',
            sortable: true, comparator: Helper.dateSortingAgGrid,
            filter: 'agDateColumnFilter',
            filterParams: {
                suppressAndOrCondition: true,
                comparator: Helper.calendarAgGridComparator,
            }, minWidth: 150
        },
        {
            field: 'UpdatedOn',
            headerName: 'UPDATED ON',
            headerTooltip: 'UPDATED ON',
            sortable: true,
            comparator: Helper.dateSortingAgGrid,
            filter: 'agDateColumnFilter',
            filterParams: {
                suppressAndOrCondition: true,
                comparator: Helper.calendarAgGridComparator,
            }, minWidth: 150
        },
        { field: 'OrderBlock', headerName: 'ORDER BLOCK', headerTooltip: 'ORDER BLOCK', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'CreditRisk', headerName: 'CREDIT RISK', headerTooltip: 'CREDIT RISK', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'Payment', headerName: 'PAYMENT', headerTooltip: 'PAYMENT', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'SdiNumber', headerName: 'SDI NUMBER', headerTooltip: 'SDI NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
        { field: 'PecEmail', headerName: 'PEC EMAIL', headerTooltip: 'PEC EMAIL', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
    ]);

    const fetchAPICall = async () => {
        __set('USER_ACCOUNT_API_CALL')
        if (Object.entries(filter_list).length > 0) {
            const params = {
                accountName: filter_list?.accountName?.searchKeyword ? filter_list?.accountName?.searchKeyword : null,
                accountNumber: filter_list?.accountNumber?.searchKeyword ? filter_list?.accountNumber?.searchKeyword : null,
                speedBoat: filter_list?.speedboat?.searchKeyword ? (filter_list?.speedboat?.searchKeyword === "Silica" ? 'S' : filter_list?.speedboat?.searchKeyword === "Abacus" ? 'T' : 'B') : null,
                salesOrg: filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr.map(item => item.value) : [],
                isActive: filter_list?.accountActive?.searchKeyword ? (filter_list?.accountActive?.searchKeyword === "Yes") : null,
                country: filter_list?.country?.searchKeywordArr ? filter_list?.country?.searchKeywordArr.map(item => item.value) : [],
                createdDate: filter_list?.createdDate?.searchKeyword ? Helper.convertToYYMMDD(filter_list?.createdDate?.searchKeyword) : null,
            }
            const filterListObject = filter_list?.speedboat?.searchKeyword

            if (!filterListObject) {
                setUserListErrAlert(
                    "Please select Speedboat",
                    "danger",
                    "searchAccount"
                );
                setErrAlertType("danger");
                __remove('USER_ACCOUNT_API_CALL')
                return;
            }
            await get_account_list(params)
        } else {
            set_account_list()
        }
        __remove('USER_ACCOUNT_API_CALL')
    };
    const gridUpdateCallback = (event) => {
        setAgGridFiltered(event.api.getDisplayedRowCount());
    }

    const onGridReady = (params) => {
        setAgGridFiltered(params.api.getDisplayedRowCount());
        params.api.addEventListener('filterChanged', gridUpdateCallback)
        params.api.addEventListener('filterModified', gridUpdateCallback)
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }

    const exportGrid = async () => {
        $('#emailFilter').removeClass('open');
        __set('COMMON_API_CALL');
        if (agGridFiltered <= 2000) {
            // Fetch All Columns
            const allColumnState = gridColumnApi.getColumnState();
            // Filter Out Visible Columns
            const customColumns = allColumnState?.filter((column) => column.hide !== true && column.colId != '0')
                .map((column) => column.colId);

            let params = { fileName: `account_list.xlsx`, sheetName: "Account", columnKeys: customColumns };

            gridRef.current?.api.exportDataAsExcel(params);
            setUserListErrAlert(Constants.downloadMsg, 'success', 'addUser');
            setErrAlertType('success');
        } else {
            const params = {
                accountName: filter_list?.accountName?.searchKeyword ? filter_list?.accountName?.searchKeyword : null,
                accountNumber: filter_list?.accountNumber?.searchKeyword ? filter_list?.accountNumber?.searchKeyword : null,
                speedBoat: filter_list?.speedboat?.searchKeyword ? (filter_list?.speedboat?.searchKeyword === "Silica" ? 'S' : filter_list?.speedboat?.searchKeyword === "Abacus" ? 'T' : 'B') : null,
                salesOrg: filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr.map(item => item.value) : [],
                isActive: filter_list?.accountActive?.searchKeyword ? (filter_list?.accountActive?.searchKeyword === "Yes") : null,
                country: filter_list?.country?.searchKeywordArr ? filter_list?.country?.searchKeywordArr.map(item => item.value) : [],
                createdDate: filter_list?.createdDate?.searchKeyword ? Helper.convertToYYMMDD(filter_list?.createdDate?.searchKeyword) : null,
            }
            const res = await email_accouts(params);
            setUserListErrAlert("File will be sent as an email attachment due to large number of records", 'success', 'addUser');
            setErrAlertType('success');
        }
        __remove('COMMON_API_CALL');
    }

    const onExportAll = async () => {
        $('#emailFilter').removeClass('open');
        __set('COMMON_API_CALL');
        if (totalRecords > 0 && totalRecords < 2000) {
            const data = await get_account_export({});
            Helper.downloadFileFromRes(data, 'account_list.xlsx');
            setUserListErrAlert(Constants.downloadMsg, 'success', 'addUser');
            setErrAlertType('success');
        } else {
            const res = await email_accouts();
            setUserListErrAlert("File will be sent as an email attachment due to large number of records", 'success', 'addUser');
            setErrAlertType('success');
        }
        __remove('COMMON_API_CALL');
    }
    return (
        <>
            {rowData.length > 0 &&
                <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
                    <div className="d-flex justify-content-start">
                        Filtered Line Count: <b>{agGridFiltered}</b>
                    </div>
                    <div className="d-flex justify-content-end">
                        Total Records: <b>{totalRecords}</b>
                    </div>
                </div>}
            <div className='bg-black p-2'>
                <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center'></div>
                    <div className='d-flex align-items-center'>
                        <span id="emailFilter" className="dropdown me-2">
                            <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white'>
                                <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
                            </a>
                            <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton1">
                                <li><a href={void (0)} onClick={onExportAll}>Export All</a></li>
                                {rowData.length > 0 && <li><a href={void (0)} onClick={exportGrid}>Export Filtered</a></li>}
                            </ul>
                        </span>
                    </div>
                </div>
            </div>
            {__check(['USER_ACCOUNT_API_CALL', 'COMMON_API_CALL']).render}
            {!__check(['USER_ACCOUNT_API_CALL', 'COMMON_API_CALL']).status &&
                <>
                    {rowData?.length > 0 ?
                        <div className="ag-theme-alpine ag-grd-hg mb-5">
                            <AgGridReact
                                ref={gridRef}
                                rowData={rowData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                suppressRowClickSelection={true}
                                onGridReady={onGridReady}
                                autoGroupColumnDef={{
                                    headerName: 'Group',
                                    minWidth: 220,
                                }}
                            >
                            </AgGridReact>
                        </div> :
                        <>
                            {Object.entries(filter_list).length > 0 ?
                                <div className='container mt-5'>
                                    <NoResultContent message={`Sorry! We can't find any results based on your selection.`} isDisplay={false} />
                                </div>
                                : <div className='d-block pt-5 pb-5 mt-5 mb-5 minh150'> </div>
                            }
                        </>

                    }
                </>
            }
        </>

    );

}

export default AccountList;